export function shouldShowGpxSelectFilterClear(
  value: string,
  showClear = true,
): boolean {
  return showClear && value.trim().length > 0
}
